// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DriverLeadEntityMapper from "../entity-mapper/DriverLeadEntityMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as DriverPaymentHistoryEntityMapper from "../entity-mapper/DriverPaymentHistoryEntityMapper.bs.js";

var execute = DriverLeadEntityMapper.execute;

var DriverLeadResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var DriverLeadResponseConverter = partial_arg(DriverLeadResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = DriverPaymentHistoryEntityMapper.execute;

var DriverPaymentHistoryResponseConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var DriverPaymentHistoryResponseConverter = partial_arg$1(DriverPaymentHistoryResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  DriverLeadResponseConverterConfig ,
  DriverLeadResponseConverter ,
  DriverPaymentHistoryResponseConverterConfig ,
  DriverPaymentHistoryResponseConverter ,
  
}
/* DriverLeadResponseConverter Not a pure module */
